module.exports = __webpack_public_path__ + "img/3.e563a9f1.jpg";